import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "dialog dialog--info" }
const _hoisted_2 = { class: "dialog__body" }
const _hoisted_3 = { class: "confirm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "slide",
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-overlay",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.overlayClicked($event)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "dialog__close",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.overlayClicked($event)), ["self"]))
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("header", null, " Reissue tickets ", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "xhtml" }, [
                    _createElementVNode("p", null, " If you cant locate your e-tickets, please click resend and your tickets will be emailed to you. Please check your email address is correct in the account setup to ensure script. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_BaseInput, {
                      name: "name",
                      label: "Please enter your email",
                      placeholder: "Email",
                      modelValue: _ctx.v$.email.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
                      hasError: _ctx.v$.email.$error,
                      errors: _ctx.v$.email.$errors,
                      valid: !_ctx.v$.email.$invalid
                    }, null, 8, ["modelValue", "hasError", "errors", "valid"]),
                    (_ctx.isAgent === true)
                      ? (_openBlock(), _createBlock(_component_BaseCheckbox, {
                          key: 0,
                          id: "priced",
                          name: "priced",
                          label: "Send priced confirmation",
                          modelValue: _ctx.v$.pricedConfirmation.$model,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.pricedConfirmation.$model) = $event)),
                          hasError: _ctx.v$.pricedConfirmation.$error,
                          errors: _ctx.v$.pricedConfirmation.$errors,
                          valid: !_ctx.v$.pricedConfirmation.$invalid
                        }, null, 8, ["modelValue", "hasError", "errors", "valid"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("footer", null, [
                    _createVNode(_component_BaseButton, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show = false)),
                      disabled: _ctx.loading,
                      class: _normalizeClass('button--white')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_BaseButton, {
                      onClick: _withModifiers(_ctx.submit, ["stop"]),
                      loading: _ctx.loading,
                      disabled: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("account.bookings.resendConfirmation")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}